// packages import
import { Stack, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
// component import
import { StickyTable } from "../common/StickyTable";
import { LawTypeMenu } from "../menus/LawType";
import { LawTypeSkeleton } from "../skeletons/LawTypeSkeleton";
// others
import { LAW_TYPE_TABLE_HEADERS } from "../../constants";
import { LawTypeListingProps } from "../../interfaceTypes";
import { StatusBox } from "../../theme/styleComponents";

export const LawTypeListing: FC<LawTypeListingProps> = ({ loading, allLawTypes, dispatch }): JSX.Element => (
  <StickyTable height='199px'>
    <TableHead>
      <TableRow>
        {LAW_TYPE_TABLE_HEADERS.map((item, index) => {
          const lastIndex = LAW_TYPE_TABLE_HEADERS.length - 1 === index

          return (
            <TableCell
              component="th"
              key={index}
              sx={{ maxWidth: lastIndex ? '100px' : 'unset', minWidth: lastIndex ? '50px' : '150px' }}
            >
              {item}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>

    {loading ?
      <LawTypeSkeleton noOfRows={10} />
      :
      <TableBody>
        {allLawTypes?.map(lawType => {
          const { id, name, caseTypes, syncWithOutlook } = lawType || {}
          const caseTypesLength = caseTypes?.length
          const switchBorderColor = syncWithOutlook ? 'green' : 'red'

          return (
            <TableRow key={id} hover>
              <TableCell>
                <Link to={id!}>
                  <Tooltip title={name} arrow placement='top-start'>
                    <Typography noWrap maxWidth='250px' color='primary.main'>
                      {name}
                    </Typography>
                  </Tooltip>
                </Link>
              </TableCell>

              <TableCell>
                <Stack direction='row' gap={2} minWidth={300}>
                  <Typography textTransform='capitalize'>
                    {caseTypesLength === 0 ? 'No' : caseTypesLength} matter types
                  </Typography>

                  <StatusBox variant='subtitle2' borderColor={switchBorderColor}>
                    {syncWithOutlook ? "Sync with Outlook" : "Not Sync with Outlook"}
                  </StatusBox>
                </Stack>
              </TableCell>

              <TableCell>
                <LawTypeMenu lawType={lawType} dispatch={dispatch} />
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    }
  </StickyTable>
)